import { render } from "./EmailDraft.vue?vue&type=template&id=911b57dc&scoped=true"
import script from "./EmailDraft.vue?vue&type=script&lang=js"
export * from "./EmailDraft.vue?vue&type=script&lang=js"

import "./EmailDraft.vue?vue&type=style&index=0&id=911b57dc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-911b57dc"]])

export default __exports__